// The steps a plan zooms through, 1 fitting it to its frame.
const zooms = [1, 1.5, 2, 3]

// ZoomControls zoom a site's plan in and out and fit it again, on the Maps
// page and beside live view alike.
export function ZoomControls({ zoom, onZoom }: { zoom: number; onZoom: (zoom: number) => void }) {
  return (
    <div role="group" aria-label="Zoom" className="absolute right-3 bottom-3 flex items-center gap-1.5">
      <span className="h-7 px-2 inline-flex items-center rounded-md bg-black/65 text-xs font-mono text-zinc-100 tabular-nums">
        {`${Math.round(zoom * 100)}%`}{zoom > 1 && ' · drag to move'}
      </span>
      <button type="button" aria-label="Zoom out" disabled={zoom <= zooms[0]} onClick={() => onZoom(zooms[Math.max(0, zooms.indexOf(zoom) - 1)])} className="w-9 h-9 rounded-md border border-zinc-700 bg-zinc-900 text-lg text-zinc-100 hover:bg-zinc-800 disabled:opacity-40">−</button>
      <button type="button" aria-label="Zoom in" disabled={zoom >= zooms[zooms.length - 1]} onClick={() => onZoom(zooms[Math.min(zooms.length - 1, zooms.indexOf(zoom) + 1)])} className="w-9 h-9 rounded-md border border-zinc-700 bg-zinc-900 text-lg text-zinc-100 hover:bg-zinc-800 disabled:opacity-40">+</button>
      <button type="button" onClick={() => onZoom(1)} className="h-9 px-2.5 rounded-md border border-zinc-700 bg-zinc-900 text-xs font-semibold text-zinc-100 hover:bg-zinc-800">Fit</button>
    </div>
  )
}
